import { BasePrinter } from './BasePrinter';
import { IdeaFormerPrinter } from './IdeaFormerPrinter';
import { TsolesPrinter } from './TsolesPrinter';
import { PRINTER_NAMES } from '../models/PrinterSetting'
import { Group } from 'models/Group';

export type PrinterType =
  typeof PRINTER_NAMES[keyof typeof PRINTER_NAMES];

export function createPrinter(type: PrinterType): BasePrinter {
  switch (type) {
    case PRINTER_NAMES.IDEAFORMER:
      return new IdeaFormerPrinter();
    case PRINTER_NAMES.TSOLES:
      return new TsolesPrinter();
    case PRINTER_NAMES.PODO:
      return new TsolesPrinter();
    default:
      throw new Error(`Unsupported printer OS: ${type}`);
  }
}

export function getPrinterTypeByUserGroup(gr: Group | undefined | null): PrinterType{
  if(gr === undefined || gr== null) return PRINTER_NAMES.TSOLES;
  if(gr.IsDarco) return PRINTER_NAMES.IDEAFORMER;
  return PRINTER_NAMES.TSOLES;
}